import { TranslateService } from '@ngx-translate/core';

import { TranslationKeyMap } from '../fl-winning.i18n';
import { ColumnConfigItem, Icon } from '../model/fl-winning.global.model';
import { SortDirection } from '../model/sort-direction.model';
const textAlign = 'text-align';
const headersContent = 'headers-content';
export function getFrontlineWPColumnConfigItemsConfig(
    tls: TranslateService,
): ColumnConfigItem[] {
    return [
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._7443_TEAM___),
            colstyle: {
                width: '20rem',
                'max-width': '20rem',
                'min-width': '12rem',
            },
            active: true,
            styles: {},
            class: [],
            headerContentClass: 'header-content-oa',
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(
                TranslationKeyMap._11080_FRONT_LINE_WINNING_PERCENTAGE___,
            ),
            active: true,
            colstyle: { width: '10%' },
            styles: {
                width: '10%',
                'min-width': '6.5rem',
                'max-width': '6.5rem',
            },
            icon: [
                new Icon({
                    class: [
                        'chevron-up',
                        'chevron-down',
                        'unfold-more-horizontal',
                    ],
                    counter: SortDirection.DESC,
                    defaultState: SortDirection.DESC,
                    state: true,
                    action: 'sortTeamByScore',
                    prop: 'oaSort',
                    actionParams: {},
                }),
            ],
            class: [],
            headerContentClass: headersContent,
            cellstyles: {
                [textAlign]: 'center',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(
                TranslationKeyMap._11142_COMMITMENTS_ASSESSED___,
            ),
            active: true,
            colstyle: { width: '12%' },
            styles: {
                width: '12%',
                'min-width': '7.5rem',
                'max-width': '7.5rem',
            },
            icon: [
                new Icon({
                    class: [
                        'chevron-up',
                        'chevron-down',
                        'unfold-more-horizontal',
                    ],
                    counter: SortDirection.DEFAULT,
                    state: true,
                    action: 'sortTeamByExpected',
                    prop: 'expectedSort',
                    actionParams: {},
                }),
            ],
            class: [],
            headerContentClass: headersContent,
            cellstyles: {
                [textAlign]: 'center',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._11143_WINNING_DATA___),
            active: true,
            colstyle: {
                width: '23%',
            },
            colclass: 'last-col',
            styles: {
                width: '23%',
                'max-width': '94rem',
            },
            class: ['funded-coaching-bar-container'],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'center',
            },
            left: {
                class: 'fl-winning-grid-legend-box',
                content: `
                    <div class='fl-winning-grid-legend-box-coached'>
                        <span>${
                            tls.instant(
                                TranslationKeyMap._10085_WINNING___,
                            ) as string
                        }</span>
                    </div>
                    <div class='fl-winning-grid-legend-box-neutral-coached'>
                        <span>${
                            tls.instant(
                                TranslationKeyMap._10086_NEUTRAL___,
                            ) as string
                        }</span>
                    </div>
                    <div class='fl-winning-grid-legend-box-uncoached'>
                        <span>${
                            tls.instant(
                                TranslationKeyMap._10087_LOSING___,
                            ) as string
                        }</span>
                    </div>
                `,
            },
        }),
    ];
}
